export const locale = {
    lang: 'zh',
    data: {
        confirm_dialog: {
            cancel: '取消',
            confirm: '确定'
        }
    }
};
